import { fromJS } from 'immutable';
export var SET_MESSAGE_TYPE_LIST = 'live-message/SET_MESSAGE_TYPE_LIST';
export var SET_NEW_MESSAGE_DATA = 'live-message/SET_NEW_MESSAGE_DATA';
export var SET_MESSAGE_DRAFT_DATA = 'live-message/SET_MESSAGE_DRAFT_DATA';
export var SET_MESSAGE_PUBLISHED_DATA = 'live-message/SET_MESSAGE_PUBLISHED_DATA';
export var SET_NEW_MESSAGE_SORT = 'live-message/SET_NEW_MESSAGE_SORT';
export var SET_MESSAGE_DRAFT_SORT = 'live-message/SET_MESSAGE_DRAFT_SORT';
export var SET_PUBLISHED_SORT = 'live-message/SET_PUBLISHED_SORT';
export var SET_DIALOG_INFO = 'live-message/SET_DIALOG_INFO';
export var CLEAR_DIALOG_INFO = 'live-message/CLEAR_DIALOG_INFO';
export var setMessageTypeList = function setMessageTypeList(data) {
  return {
    type: SET_MESSAGE_TYPE_LIST,
    data: data
  };
};
export var setNewMessageData = function setNewMessageData(data) {
  return {
    type: SET_NEW_MESSAGE_DATA,
    data: data
  };
};
export var setMessageDraftData = function setMessageDraftData(data) {
  return {
    type: SET_MESSAGE_DRAFT_DATA,
    data: data
  };
};
export var setMessagePublishedData = function setMessagePublishedData(data) {
  return {
    type: SET_MESSAGE_PUBLISHED_DATA,
    data: data
  };
};
export var setNewMessageSort = function setNewMessageSort(sort) {
  return {
    type: SET_NEW_MESSAGE_SORT,
    sort: sort
  };
};
export var setMessageDraftSort = function setMessageDraftSort(sort) {
  return {
    type: SET_MESSAGE_DRAFT_SORT,
    sort: sort
  };
};
export var setPublishedSort = function setPublishedSort(sort) {
  return {
    type: SET_PUBLISHED_SORT,
    sort: sort
  };
};
export var setDialogInfo = function setDialogInfo(data) {
  return {
    type: SET_DIALOG_INFO,
    data: data
  };
};
export var clearDialogInfo = function clearDialogInfo() {
  return {
    type: CLEAR_DIALOG_INFO
  };
};
var initDialogInfo = {
  mode: '',
  data: {}
};
var initialState = fromJS({
  messageTypeList: [],
  newMessageData: [],
  messageDraftData: [],
  messagePublishedData: [],
  // table sort
  newMessageSort: {
    field: 'beginTime',
    desc: true
  },
  messageDraftSort: {
    field: 'beginTime',
    desc: true
  },
  publishedSort: {
    field: 'beginTime',
    desc: true
  },
  dialogInfo: initDialogInfo
});
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_MESSAGE_TYPE_LIST:
      return state.set('messageTypeList', fromJS(action.data));

    case SET_NEW_MESSAGE_DATA:
      return state.set('newMessageData', fromJS(action.data));

    case SET_MESSAGE_DRAFT_DATA:
      return state.set('messageDraftData', fromJS(action.data));

    case SET_MESSAGE_PUBLISHED_DATA:
      return state.set('messagePublishedData', fromJS(action.data));

    case SET_NEW_MESSAGE_SORT:
      return state.set('newMessageSort', fromJS(action.sort));

    case SET_MESSAGE_DRAFT_SORT:
      return state.set('messageDraftSort', fromJS(action.sort));

    case SET_PUBLISHED_SORT:
      return state.set('publishedSort', fromJS(action.sort));

    case SET_DIALOG_INFO:
      return state.set('dialogInfo', fromJS(action.data));

    case CLEAR_DIALOG_INFO:
      return state.set('dialogInfo', fromJS(initDialogInfo));

    default:
      return state;
  }
}